import styled from '@emotion/styled'

const Wrapper = styled.div`
  margin: 0;
`

export default Wrapper
